export const LIST_VIEW_TOKEN_WIDTH = 240;
export const LIST_VIEW_TOKEN_TYPOGRAPHY_WIDTH = 480;
